class Customer.ResponseTemplateSelectView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/response_template/select"]
  templateOption: JST["backbone/templates/customer/ticket/response_template/select_option"]
  templateSpinner: JST["backbone/templates/customer/ticket/response_template/spinner_item"]

  className: 'select-template'
  events:
    'click #delete-text': 'onClickDeleteText'
    'keyup #search-text': 'searchResponses'

  initialize: (@options = {}) ->
    @modal = {
      title: I18n.t('customer.dashboard.conversations.details.response.predefined_answers.select_answer'),
      buttons: [
        {
          title: I18n.t('customer.dashboard.conversations.details.response.predefined_answers.select_answer'),
          event: 'finish'
        },
        {
          title: I18n.t('customer.dashboard.conversations.details.response.predefined_answers.cancel'),
          event: 'exit'
        },
      ]
    }
    @ticketId = @options.ticketId
    @onSelect = @options.onSelect
    @collection = Customer.ResponseTemplateCollection.getEmptyResponseCollection()
    @full_collection_size = _.size(Keepcon.Collections.allResponseTemplatesModels)
    @page = 1
    @displayed_templates = []
    @selected = new Backbone.Collection()
    @user = @options.params.user || ''
    @username = @options.params.username || ''
    @tags = @options.params.tags || []
    @labels = @options.params.labels || []
    @type = @options.params.typeForResponseTemplates
    # untyped templates are only listed if no typed ones match the ticket type
    # this could be an option in the UI or a config in the account
    @alwaysShowUntyped = true
    @text_to_search = ""
    @collection.on('all',@updateTags)
    @render()

  render: ->
    @$el.html(@template(collection: @collection))
    @list = @$el.find('.list')
    @responselist = @$el.find('#response-list')
    @tag = @$el.find('#tag')
    @label = @$el.find('#label')
    @tag.chosen({width: '97%'}).change(@_doSearchResponses)
    @label.chosen({width: '97%'}).change(@_doSearchResponses)
    @updateTags()
    @updateLabels()
    @updateList()
    @searchstring = @$el.find('#search-text')
    setTimeout =>
      @searchstring.focus()
    , 500
    @modalView = new App.ModalView({instance: @, wide: true})
    @response_editor = new Customer.ResponseTemplateEditorView
      collection: @collection
      model: new @collection.model()
      modalView: @modalView
      new: true
      labels: @labels
    @response_editor.on('updateList', @updateList)
    @responselist.on('scroll', @listen_scroll)
    @listenTo(@modalView, 'modal:closed', ->
      @list.empty();
    )
    @responselist.html(@templateSpinner())
    @load_more_responses()
    @modalTab = @modalView.firstTab
    @modalTab._activate()

  _renderList: (list) ->
    @list.empty();
    list = _.filter(list, (model) -> model.isActive())
    _.each(list, (model) =>
      temp = $(@templateOption({model: model}))
      temp.on('click', null, model, @clicked)
      temp.addClass('selected') if @isSelected(model)
      @list.append(temp)
    )
    @removeSpinner()

  exit: =>
    @collection = Customer.ResponseTemplateCollection.getCollection()
    @list.empty()
    @modalView.destroy()

  finish: =>
    @eventAggregator.trigger('customer:dashboard:selectTemplateAnswer', @selected.models)
    finalText = @collection.finalText(@selected.models, @user, @ticketId, @username)
    @onSelect(finalText)
    @exit()

  clicked: (event) =>
    model = event.data
    selected = @isSelected(model)
    if(selected)
      @removeSelected(model)
    else
      @addSelected(model)
    $(event.currentTarget).children('.span9.text').toggleClass('selected', !selected)
    $(event.currentTarget).toggleClass('selected', !selected)

  addSelected: (model) ->
    @selected.add(model)

  removeSelected: (model) ->
    @selected.remove(model)

  isSelected: (model) ->
    !!@selected.get(model.id)

  hasPredefinedTemplateWithTags: ->
    @collection.hasMatchingTagsForType(@tags, @type, @alwaysShowUntyped)

  hasPredefinedTemplateWithLabels: ->
    @collection.hasMatchingLabelsForType(@collection.getLabelIDs(@labels), @type, @alwaysShowUntyped)

  updateTags: =>
    @tag.empty()
    @tag.append("<option selected value='any'>#{I18n.t('customer.dashboard.conversations.details.response.predefined_answers.any_tag')}</option>")
    @tag.append("<option #{'selected' if @hasPredefinedTemplateWithTags()} value='all-response-tags-selected'> #{I18n.t('customer.dashboard.conversations.details.response.predefined_answers.matched_tags')}</option>")
    _.chain(@collection.possibleTags)
      .filter( (tag) => @collection.hasMatchingTagsForType([tag['code']], @type) )
      .sortBy( (tag) -> tag.description.toLowerCase() )
      .each( (tag) => @tag.append("<option value='#{tag['code']}'>#{tag['description']}</option>") )
    @tag.trigger('chosen:updated')

  updateLabels: =>
    @label.empty()
    @label.append("<option selected value='any'>#{I18n.t('customer.dashboard.conversations.details.response.predefined_answers.any_group')}</option>")
    @label.append("<option #{'selected' if @hasPredefinedTemplateWithLabels()} value='all-response-labels-selected'> #{I18n.t('customer.dashboard.conversations.details.response.predefined_answers.matched_groups')}</option>")
    _.chain(@collection.getLabelsNames())
      .filter( (label) => @collection.hasMatchingLabelsForType(@collection.getLabelIDs([label]), @type, @alwaysShowUntyped))
      .sortBy( (label) => label.toLowerCase())
      .each( (label) => @label.append("<option value='#{label}'>#{label}</option>"))
    @label.trigger('chosen:updated')

  onClickDeleteText: ->
    @text_to_search = ''
    @searchstring.val('')
    @clearResponseCollection()
    @collection.has_more = true
    @load_more_responses()

  filterTemplates: (models, word) =>
    result = []
    for model in models
      result.push(model) if @hasWord(model.attributes.template, word) || @hasWord(model.attributes.title, word)
    return result

  hasWord: (string, substring) =>
    string.toUpperCase().indexOf(substring.toUpperCase()) != -1

  selectedTag: () ->
    @tag.val()

  selectedLabel: () ->
    @label.val()

  selectedTags: ->
    tag = @selectedTag()
    return {list: @tags, include_global: false, any: false}   if tag == 'all-response-tags-selected'
    return {list: [], include_global: false, any: true}      if tag == 'any'
    return {list: [tag], include_global: false, any: false}

  selectedLabels: ->
    label = @selectedLabel()
    return {list: @labels, include_global: false, any: false}  if label == 'all-response-labels-selected'
    return {list: [], include_global: false, any: true}      if label == 'any'
    return {list: [label], include_global: false, any: false}

  clearResponseCollection: =>
    @list.empty()
    @displayed_templates = []
    @page = 1

  updateList: =>
    @_renderList(@collection.getModelsMatchingWithTextSearch(@text_to_search, @selectedTags(), @selectedLabels(), @type, @alwaysShowUntyped))

  setUser: (user) ->
    @user = user

  load_more_responses: =>
    if @collection.has_more
      @appendSpinner()
      @_doSearch()

  searchResponses: =>
    if _.size(@searchstring.val()) >= @collection.minLettersToSearch(@full_collection_size)
      clearTimeout @fired_search
      @fired_search = setTimeout @_doSearchResponses, 500
    else if _.size(@searchstring.val()) == 0
      @onClickDeleteText()
    else
      @clearResponseCollection()

  _doSearchResponses: =>
    @collection.has_more = true
    @clearResponseCollection()
    @text_to_search = @searchstring.val()
    @_doSearch()

  _doSearch: =>
    @appendSpinner()

    matching_templates = @collection.getModelsMatchingWithTextSearch(@text_to_search, @selectedTags(), @selectedLabels(), @type, @alwaysShowUntyped)
    active_matching_templates = _.filter(matching_templates, (model) -> model.isActive())
    paginator = new Monitoring.Models.ModelPaginator(active_matching_templates, 15)
    templates = paginator.page(@page)
    @updateResponses(templates, paginator)


  updateResponses: (templates, paginator) =>
    if _.isEmpty(templates)
      @collection.has_more = false
      proceed = true
      @removeSpinner()
      return
    @displayed_templates = @displayed_templates.concat(templates)
    @_renderList(@displayed_templates)

  listen_scroll: =>
    _horizontalScrollMarginOfError = 20
    _height = @responselist.prop('scrollHeight') - _horizontalScrollMarginOfError
    _scrolled = @responselist.prop('scrollTop') + @responselist.height()
    if _scrolled >= _height && @responselist.prop('scrollTop') > 0 && !@spinnerAdded()
      @page = @page + 1
      @load_more_responses()

  appendSpinner: =>
    @list.append(@templateSpinner()) if !@spinnerAdded()
  removeSpinner: =>
    @list.children().last().remove() if @spinnerAdded()

  spinnerAdded: =>
    @list.children().last().attr('id') == "spinner_item"

  labelsIdsToSearch: =>
    _.pluck _.filter(@collection.labels, (label) ->
      _.contains(@selectedLabels().list, label.name)
    , @), 'id'
